//import { ChartTypes } from '@servahealth/serva-ui-kit';

export enum ServaChartTypes {
    area = 1,
    column = 2,
    line = 3,
    stepLine = 4,
    spline = 5,
    stepArea = 6,
    splineArea = 7,
    bar = 8,
    pie = 9,
    pyramid = 10,
    doughnut = 11,
    stackedColumn = 12,
    stackedBar = 13,
    usmap = 14
  };
  
export interface ServaChartOptions {
    type: ServaChartTypes | undefined;
    vertical: boolean;
    multiaxis: boolean;
    showLegend: boolean;
    fill: boolean;
}
